export default {
  setResourceInfo ({commit}, val) {
    commit('SET_RESOURCE_INFO', val)
  },
  setOaQuery ({commit}, val) {
    commit('SET_OA_QUERY', val)
  },
  setOaZjInfo ({commit}, val) {
    commit('SET_OA_ZJ_INFO', val)
  },
}
